"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDraggingRestriction = exports.isDrawingRestriction = exports.RESTRICTION_TYPE = void 0;
// #endregion Interfaces (4)
// #region Enums (1)
var RESTRICTION_TYPE;
(function (RESTRICTION_TYPE) {
    RESTRICTION_TYPE["PLANE"] = "plane";
    RESTRICTION_TYPE["GEOMETRY"] = "geometry";
    RESTRICTION_TYPE["POINT"] = "point";
    RESTRICTION_TYPE["LINE"] = "line";
    RESTRICTION_TYPE["CAMERA_PLANE"] = "camera_plane";
})(RESTRICTION_TYPE = exports.RESTRICTION_TYPE || (exports.RESTRICTION_TYPE = {}));
// #endregion Enums (1)
// #region Variables (2)
const isDrawingRestriction = (metaData) => {
    return (metaData === null || metaData === void 0 ? void 0 : metaData.type) === 'drawing';
};
exports.isDrawingRestriction = isDrawingRestriction;
const isDraggingRestriction = (metaData) => {
    return (metaData === null || metaData === void 0 ? void 0 : metaData.type) === 'dragging';
};
exports.isDraggingRestriction = isDraggingRestriction;
// #endregion Variables (2)
//# sourceMappingURL=IRestriction.js.map